/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const Projection = z.object({
  confidence: z.string(),
  projectedAcquisitionDate: z.string(),
  servicesOfInterest: z.array(z.string()),
  targetCCU: z.string(),
  targetGA: z.string()
})

export interface Projection extends z.TypeOf<typeof Projection> {}
